import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Box,
  CircularProgress,
} from '@mui/material';
import type { ITag } from 'services/api/entities';
import type { TagStore } from 'services/store/tags';
import theme from 'theme';
import { TagType } from 'services/api/responses/responseTypes';

type PropsType = {
  isLoading: boolean;
  tagType: TagType;
  tagStore: TagStore;
  selectTag: (tag: ITag) => void;
};

const MobileTagsList = (props: PropsType): React.ReactElement => {
  const { isLoading, tagType, tagStore, selectTag } = props;

  const getTags = () => tagStore[tagType] ?? [];

  const getSelectedTags = () => tagStore.selectedTags[tagType] ?? [];

  const displayTagList = () => (
    <>
      <FormGroup data-testid="mobile-tags-list">
        {/* @ts-ignore */}
        {getTags().map((id: string) => {
          const tag: ITag = tagStore.tags[id];
          const isSelected: boolean = getSelectedTags().includes(tag);
          return (
            <FormControlLabel
              key={tag.id}
              label={tag.name}
              control={
                <Checkbox
                  sx={{
                    '&.Mui-checked': {
                      '&, & + .MuiFormControlLabel-label': {
                        color: theme.palette.primary.main,
                      },
                    },
                  }}
                  onChange={() => selectTag(tag)}
                  checked={isSelected}
                />
              }
            />
          );
        })}
      </FormGroup>
    </>
  );

  const displayCircularProgress = () => (
    <Box sx={{ pl: '27vw' }} data-testid="tags-loading-indicator">
      <CircularProgress color="primary" size="2rem" />
    </Box>
  );
  return (
    <>
      <Box sx={{ maxHeight: '51vh', overflowY: 'auto' }}>
        {isLoading ? displayCircularProgress() : displayTagList()}
      </Box>
    </>
  );
};

export default MobileTagsList;
